import React from "react";
import logo from "./assets/hallef-logo-cropped.png";
import "./loading-state.css";

export default function LoadingState() {
  return (
    <main className="loading-state-page" aria-labelledby="loading-state-title">
      <img className="loading-state-logo" src={logo} alt="Hallef Technologies" />
      <section className="loading-state-card" role="status" aria-live="polite">
        <div className="loading-state-icon" aria-hidden="true">
          <span className="loading-state-spinner" />
        </div>
        <p className="loading-state-eyebrow">PLEASE WAIT</p>
        <h1 id="loading-state-title">Loading your page</h1>
        <p className="loading-state-description">
          We're getting everything ready for you. This may take a moment.
        </p>
        <div className="loading-state-dots" aria-hidden="true"><span /><span /><span /></div>
      </section>
      <p className="loading-state-footer">Hallef Technologies</p>
    </main>
  );
}
